<template>
    <div class="overflow-hidden">
        <v-radio-group v-model="deliveryType" v-bind="attrs_controls_common" @change="emit">
            <v-radio label="단건배송" value="single" />
            <v-radio label="정기배송" value="regular" v-if="product?.regularDeliveryEnabled" />
            <v-radio label="재고주문" value="stock" v-if="product?.stockOrderConf?.enabled" />
        </v-radio-group>
    </div>
</template>

<script>
import { attrs_controls_common } from "@/assets/variables";

export default {
    props: {
        value: { type: String, default: "single" }, // deliveryType
        product: { type: Object, default: null },
    },
    setup: () => ({
        attrs_controls_common,
    }),
    data: () => ({
        deliveryType: "single",
    }),
    methods: {
        sync() {
            this.deliveryType = this.value;
        },
        emit() {
            this.$emit("input", this.deliveryType);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped>
.v-input--checkbox,
.v-simple-checkbox,
.v-radio {
    ::v-deep {
        .v-input--selection-controls__ripple:before {
            display: none !important;
        }
    }
}
</style>
